/* eslint prettier/prettier: "off" */
/* eslint no-use-before-define: "off" */
/* eslint quotes: "off" */
/* eslint unicorn/prefer-code-point: "off" */

/**
 * DO NOT EDIT!!
 *
 * This is a copy and paste of a fully tested util file called from banking-web repo.
 * We are copying because we want the code to be the same for both dashboard and banking-web
 * when working with bb-debit Card.
 *
 * https://github.com/squareup/banking-web/blob/main/src/util/image-bytes-utils-v2.ts
 */

export const getImageUriFromCardCustomization = customization => {
  const {
    imageBytes,
    mimeType
  } = customization;
  if (imageBytes == null || mimeType == null) {
    return "";
  }
  if (imageBytes.length === 0 || mimeType.length === 0) {
    return "";
  }
  const imageString = convertUint8ArrayToString(imageBytes);
  return `data:${mimeType};base64,${imageString}`;
};
export const convertUint8ArrayToString = bytes => {
  const bin = bytes.reduce((arr, byte) => {
    arr.push(String.fromCharCode(byte));
    return arr;
  }, []).join("");
  return btoa(bin);
};